import { useEffect } from "react";
import Cookies from "js-cookie";

// Import the correct type for Cookies
import type { CookieAttributes } from "js-cookie";
import {v4 as uuidv4} from "uuid";

const CookieHandler: React.FC = () => {
    useEffect(() => {
        const ttlUuid: string | undefined = Cookies.get("ttd_id");
        if (!ttlUuid) {
            const uniqueId = uuidv4();
            const options: CookieAttributes = {path: "/"};
            Cookies.set("ttd_id", uniqueId, options);
        }
    }, []);

    return null;
};

export default CookieHandler;
